// Personal por ratio (camareros y extras de un menú). Mismo criterio que
// `personal_por_ratio` de backend/utils.py: se redondea hacia arriba, salvo que
// el exceso sobre el múltiplo inferior no pase del 20 % del ratio, que lo cubren
// los que ya van. Ej. ratio 80: 96 pax -> 1; 100 pax -> 2; 180 pax -> 3.
export const TOLERANCIA_RATIO_PERSONAL = 0.2;

// `desdeRatio`: solo cuenta a partir de `ratio` personas (los extras).
export const personalPorRatio = (numPersonas, ratio, desdeRatio = false, tolerancia = TOLERANCIA_RATIO_PERSONAL) => {
  const pax = Number(numPersonas) || 0;
  const r = Number(ratio) || 0;
  if (pax <= 0 || r <= 0) return 0;
  if (desdeRatio && pax < r) return 0;
  const exacto = pax / r;
  const base = Math.floor(exacto);
  const n = exacto - base <= tolerancia + 1e-9 ? base : base + 1;
  return Math.max(1, n);
};
